<template>
  <v-layout column>
    <v-alert v-if="notif"
             prominent
             :type="notif.type"
             dismissible
             class="ma-6"
             @input="clearNotif">
      {{notif.message}}
    </v-alert>
    <component :is="currentView"></component>
  </v-layout>
</template>

<script>
  import SubscriptionHome from '../components/SubscriptionHome';
  import NotLoggedIn from '../components/NotLoggedIn';
  import Loading from "../components/Loading";
  import Unverified from "../components/Unverified";
  import NewPassword from "../components/NewPassword";
  import About from "../views/About.vue"

  export default {
    components: {
      SubscriptionHome,
      NotLoggedIn,
      Loading,
      About
    },
    data: () => ({
      
    }),
    computed: {
      user() {
        return this.$store.state.user;
      },
      isLoggedIn() {
        return this.$store.state.loggedIn;
      },
      currentView() {
        if (typeof this.isLoggedIn === 'undefined')
          return Loading
        if (this.isLoggedIn) {
          if (!this.user.isVerified)
            return Unverified;
          else switch (this.user.accessLevel) {
            case "PASSWORD_RESET":
              return NewPassword;
            case "UNVERIFIED":
              return Unverified;
            case "STANDARD":
            default:
              return SubscriptionHome;
          }
        }
        return About
      },
      notif() {
        return this.$store.state.notification;
      }
    },
    methods: {
      clearNotif() {
        this.$store.commit("setNotification", null);
      }
    }

  };
</script>
